module.exports = __webpack_public_path__ + "static/media/jp.981e32ba.png";